import { render } from "./LP-THLLernstoff.vue?vue&type=template&id=d8db3960&scoped=true"
import script from "./LP-THLLernstoff.vue?vue&type=script&lang=js"
export * from "./LP-THLLernstoff.vue?vue&type=script&lang=js"

import "./LP-THLLernstoff.vue?vue&type=style&index=0&id=d8db3960&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8db3960"]])

export default __exports__